<template>
  <div class="w-full">
    <svg
      class="circle md:circle-lg"
      viewBox="0 0 200 200"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient id="gradientPrimary" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:rgba(48, 63, 159, 1);stop-opacity:1"></stop>
          <stop offset="100%" style="stop-color:rgba(63, 81, 181, 1);stop-opacity:1"></stop>
        </linearGradient>
        <linearGradient id="gradientSecondary" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:rgba(239,83,80,1);stop-opacity:1"></stop>
          <stop offset="100%" style="stop-color:rgba(229,57,53,1);stop-opacity:1"></stop>
        </linearGradient>
      </defs>
      <circle
        id="Stroke"
        :stroke="secondary_color"
        stroke-opacity="1"
        fill-rule="nonzero"
        cx="50%"
        cy="50%"
        r="45%"
        fill="none"
        :stroke-linecap="cap"
        transform="rotate(-90 100 100)"
      ></circle>
      <circle
        id="Stroke"
        class="progress-circle__path"
        :stroke="primary_color"
        stroke-opacity="1"
        fill-rule="nonzero"
        cx="50%"
        cy="50%"
        r="45%"
        fill="none"
        :stroke-linecap="cap"
        transform="rotate(-90 100 100)"
        :stroke-dasharray="circle"
      ></circle>
    </svg>
    <div class="flex flex-col text-left sm:flex-row sm:items-center md:centered-text">
      <h4 class="subheader mr-3 md:mx-0">{{ text_top }}</h4>
      <div class="section vertical text-primarytext whitespace-no-wrap my-4 mr-3 md:mx-0">
        <h2 class>{{ amount }}</h2>
      </div>
      <h4 class="subheader whitespace-normal">{{text_bottom}}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "Circle_Chart",
  props: {
    amount: String,
    percent: Number,
    text_top: String,
    text_bottom: String,
    primary_color: String,
    secondary_color: String,
    cap: String
  },
  computed: {
    circle() {
      return (this.percent / 100) * 180 * Math.PI + ",9999";
    }
  }
};
</script>

<style scoped>
.progress-circle__path {
  animation: circle-chart-fill 2s cubic-bezier(0.53, 0, 0.58, 0.82) reverse;
  -webkit-animation: circle-chart-fill 2s cubic-bezier(0.53, 0, 0.58, 0.82)
    reverse;
  transition: all 2s;
}

@keyframes circle-chart-fill {
  to {
    stroke-dasharray: 0 9999;
  }
}
</style>
